const NUM_SINGLE_CHOICE = 1;
const NUM_MULTIPLE_CHOICE = 2;

export default { NUM_SINGLE_CHOICE, NUM_MULTIPLE_CHOICE };
